export function getPluginPreferenceId(plugin) {
  return plugin?.key || plugin?.id || plugin?.name || null;
}

export function normalizeFeedbackPreferences(preferences) {
  if (!preferences || typeof preferences !== "object" || Array.isArray(preferences)) {
    return {
      selectedCategory: null,
      hasUserSelectedCategory: false,
      enabledPluginIds: {},
    };
  }

  return {
    selectedCategory: preferences.selectedCategory ?? null,
    hasUserSelectedCategory: preferences.hasUserSelectedCategory === true,
    enabledPluginIds:
      preferences.enabledPluginIds && typeof preferences.enabledPluginIds === "object" && !Array.isArray(preferences.enabledPluginIds)
        ? preferences.enabledPluginIds
        : {},
  };
}

export function applyFeedbackPreferencesToInstallations(installations, preferences) {
  const normalized = normalizeFeedbackPreferences(preferences);
  const overrides = normalized.enabledPluginIds;
  if (!Array.isArray(installations) || Object.keys(overrides).length === 0) {
    return installations;
  }

  return installations.map((plugin) => {
    const id = getPluginPreferenceId(plugin);
    if (!id || typeof overrides[id] !== "boolean") return plugin;
    return { ...plugin, enabled: overrides[id] };
  });
}

export function setFeedbackPreferenceCategory(preferences, selectedCategory) {
  const normalized = normalizeFeedbackPreferences(preferences);
  return {
    ...normalized,
    selectedCategory,
    hasUserSelectedCategory: true,
  };
}

export function setFeedbackPreferencePluginEnabled(preferences, plugin, enabled) {
  const normalized = normalizeFeedbackPreferences(preferences);
  const id = getPluginPreferenceId(plugin);
  if (!id) return normalized;

  return {
    ...normalized,
    enabledPluginIds: {
      ...normalized.enabledPluginIds,
      [id]: enabled,
    },
  };
}

export function hasFeedbackPluginEnabledOverrides(preferences) {
  return Object.keys(normalizeFeedbackPreferences(preferences).enabledPluginIds).length > 0;
}

export function getEnabledFeedbackTypeNames(installations, preferences, category = null) {
  const effectiveInstallations = applyFeedbackPreferencesToInstallations(installations, preferences) || [];
  return effectiveInstallations
    .filter((plugin) => plugin?.enabled === true)
    .filter((plugin) => !category || plugin.category === category || (!plugin.category && plugin.name === category))
    .map((plugin) => plugin.name)
    .filter(Boolean);
}
